import { render } from "./AppButton.vue?vue&type=template&id=8f5ba4e8&scoped=true"
import script from "./AppButton.vue?vue&type=script&lang=ts"
export * from "./AppButton.vue?vue&type=script&lang=ts"

import "./AppButton.vue?vue&type=style&index=0&id=8f5ba4e8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8f5ba4e8"

export default script